import Axios from 'axios'

const GalleryModule = {
  namespaced: true,
  state: {
    property_1: [],
    property_2: [],
    property_3: []
  },
  mutations: {
    setGalleryItems (state, { propertyId, images }) {
      state[`property_${propertyId}`] = images
    }
  },
  actions: {
    async fetchPropertyGallery ({ commit }, { propertyId }) {
      try {
        const res = await Axios.get(`/property/${propertyId}/gallery`)
        if (res) {
          commit('setGalleryItems', { propertyId, images: res.data })
        }
      } catch (e) {
        commit('setGalleryItems', { propertyId, images: [] })
        throw e
      }
    }
  },
  getters: {
    propertyGallery: (state) => {
      return state
    }
  }
}

export default GalleryModule
